import { useSharedAPI } from "@certn/api";
import { useJsonForms } from "@jsonforms/react";
import get from "lodash.get";

import { SuggestionSelectControl } from "./SuggestionSelectControl";
import {
  withCascadiaControlProps,
  CascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

interface ValidCheck {
  check_category: string;
  position_title: string;
  reason_for_check: string;
}

function isVolunteerCheck(obj: any): obj is ValidCheck {
  if (
    obj.check_category?.type === "string" &&
    obj.reason_for_check?.type === "string" &&
    obj.requesting_organisation?.type === "string"
  ) {
    const keys = Object.keys(obj);
    return keys.length === 3;
  }

  return false;
}

export function CheckPurposesControl(props: CascadiaControlProps) {
  const context = useJsonForms();

  const category = get(context?.core?.data, "check_category");
  const properties = context?.core?.schema?.properties;
  const label = props?.label;

  const issueLabels: string[] = [
    "Company or Employer Name",
    "Licence Issuing Body",
    "Requesting Organisation",
    "Government Department",
  ];

  const isIssuer = issueLabels.includes(label);

  const { data: checkPurposesData, isLoading } = useSharedAPI(
    "/api/internal/shared/check-purposes/",
    {
      category,
      ...(isIssuer && { issuer: true }),
      type: isVolunteerCheck(properties) ? "VOLUNTEER" : "STANDARD",
    }
  );

  const suggestions = checkPurposesData?.map((purpose) => purpose).flat();

  return (
    <SuggestionSelectControl
      {...props}
      options={{
        ...props.options,
        suggestions,
      }}
      isLoading={isLoading}
    />
  );
}

CheckPurposesControl.displayName = "CheckPurposesControl";

export const CheckPurposesRenderer =
  withCascadiaControlProps(CheckPurposesControl);
